import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import DelhiNCRMain from "../Component/delhi-ncr/AboutMain";
import WhoWeAre from "./delhi-ncr/WhoWeAre";
import WhyStudyMbbsAbroad from "src/DelhiNCR/WhyStudyMbbsAbroad";
import OurValue from "./delhi-ncr/Value";
import DelhiNCRAdvantage from "src/DelhiNCR/DelhiNCRAdvantage";
import Banner from "src/DelhiNCR/Banner";
import ImmigrationQuestions from "src/DelhiNCR/ImmigrationFaq";
import Milestones from "src/Component/mildstones/Milestones";
import { useEffect } from "react";
import { Box } from "@mui/material";
import { Helmet } from "react-helmet";
import Roadmap from "src/Component/services/Roadmap";
import LetsGetStarted from "src/Component/LetsGetStarted";
import StudyAbroadGlobalCombination from "src/CountryPages/StudyAbroadMainComponents/StudyAbroadGlobalCombination";
const DelhiNCR = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      {" "}
      <Helmet>
        <title>
        Overseas Education Consultants in Greater Noida | Taksheela
        </title>
        <meta
          name="description"
          content="Find expert overseas education consultants in Greater Noida at Taksheela. Get guidance on admissions, test prep, and achieving your global education goals."
        />
        <meta
          name="keywords"
          content="best institute for your global education, Best study abroad institute in kolkata, study abroad in Delhi,"
        />
      </Helmet>
      <Navbar />
      <Banner />
      <DelhiNCRMain />
      <WhoWeAre />
      <OurValue />
      <DelhiNCRAdvantage />
      <WhyStudyMbbsAbroad />
      <Milestones />
      <Roadmap />
      <StudyAbroadGlobalCombination />
      <Box sx={{ margin: "50px 0" }}>
          <ImmigrationQuestions />
      </Box>
      <LetsGetStarted />
      <Box paddingTop={"30px"}>
        <Footer />
      </Box>
    </>
  );
};

export default DelhiNCR;
